import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home.vue";
// import Cinema from "../views/Cinema.vue";
// import FirstDiagram from "../views/FirstDiagram.vue"
// import Ova from "../views/ova.vue"
// import About from "../views/About.vue"
import Diagram from "../components/Diagram.vue"

import Page404 from "../views/404"
import FirstDiagram from "../views/FirstDiagram.vue"
import FirstDiagram1 from "../views/FirstDiagram1.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: '/FirstDiagram',
    name: 'FirstDiagram',
    component:FirstDiagram,
  },
  {
    path: '/FirstDiagram1',
    name: 'FirstDiagram1',
    component:FirstDiagram1,
  },
  {
    path: '*',
    name: '404',
    component: Page404
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
 
})
 
export default router

